import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Roles } from "~enums/roles";
import { useAddRole } from "~hooks/apiHooks/useAddRole";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UpsertFixtureRosterModel } from "~pages/Roster/FixtureRosterListPage/types/upsertFixtureRosterModel";
import type { Roster, RosterResponse } from "~types/roster";

const useUpsertFixtureRosterPlayer = () => {
  const { sport, organizationId, seasonId, fixtureId } = useParams();
  const request = useApi();
  const queryClient = useQueryClient();

  const { mutateAsync: createCaptainRole } = useAddRole();
  return useMutation<RosterResponse, Error, UpsertFixtureRosterModel>({
    mutationFn: async (upsertModel: UpsertFixtureRosterModel) => {
      const url = `${sport}/o/${organizationId}/fixtures/${fixtureId}/roster`;
      const method = "POST";
      const body = { ...upsertModel, isCaptain: undefined };
      return await request(url, { method, body });
    },
    onSuccess: async (response: { data: Array<Roster> }, upsertModel) => {
      if (response?.data && response.data.length > 0) {
        if (upsertModel.isCaptain && seasonId) {
          await createCaptainRole({
            personId: upsertModel.personId,
            entityId: upsertModel.entityId,
            seasonId,
            role: Roles.Captain,
            fixtureId,
          });
        }
        await queryClient.invalidateQueries({
          queryKey: ["fixtureRoster", sport, organizationId, seasonId],
        });
      }
    },
  });
};

export default useUpsertFixtureRosterPlayer;
